import styled from 'styled-components'
import { useMemo } from 'react'

const StyledSvg = styled.svg<{ size: number; rotate: string }>`
  width: ${props => props.size}px;
  aspect-ratio: 1;
  transform: ${props => props.rotate};

  .st0 {
    fill: #fff;
  }
`
export const ArrowInCircleIcon = ({
  size = 40,
  direction,
}: {
  size?: number
  direction?: 'to-top' | 'to-left' | 'to-right' | 'to-bottom'
}) => {
  const rotate = useMemo(() => {
    switch (direction) {
      case 'to-left':
        return 'rotate(90deg)'
      case 'to-right':
        return 'rotate(-90deg)'
      case 'to-bottom':
        return 'rotate(180deg)'
      default:
      case 'to-top':
        return 'rotate(0)'
    }
  }, [direction])

  return (
    <StyledSvg
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      viewBox='0 0 40 40'
      size={size}
      rotate={rotate}
    >
      <path
        className='st0'
        d='M18.8,28.8v-13.2l-5.2,5.2c-.5.5-1.3.5-1.8,0-.5-.5-.5-1.3,0-1.8l7.1-7.1c.3-.3.7-.4,1.1-.3.4,0,.8,0,1.1.3l7.1,7.1c.5.5.5,1.3,0,1.8-.5.5-1.3.5-1.8,0l-5.1-5.2v13.2c0,.7-.6,1.2-1.2,1.2s-1.2-.6-1.2-1.2ZM40,20C40,9,31.1,0,20,0S0,9,0,20s8.9,20,20,20,20-9,20-20Z'
      />
    </StyledSvg>
  )
}
